<template>
  <div class="card border-top-start-radius-0 border-top-end-radius-0">
    <termo-adesao-form
        :termoIdProp="state.termoId"
        v-if="showForm"
        @fecharForm="formularioTermo(false)"
    />
    <div class="card-body" v-else>
      <div class="d-lg-flex">
        <div class="my-auto mt-4 ms-auto mt-lg-0">
          <div class="my-auto ms-auto">
            <button type="button" class="mb-0 btn bg-gradient-success btn-sm" @click="formularioTermo(true)">
              +&nbsp; {{ t('newContract') }}
            </button>
          </div>
        </div>
      </div>
      <MyTable
          :data="state.termosLista"
          :columns="colunas"
          :itemsPerPage="12">
        <template v-slot:row="{ row }">
          <td class="text-sm">
            {{ row.name }}
          </td>
          <td class="text-sm text-center">
            {{ row.status == 'd' ? t('draft') : row.status == 'a' ? t('active') : t('inactive') }}
          </td>
          <td class="text-sm text-center">
            {{ $filters.datePtbr(row.initial_date) }} - {{ $filters.datePtbr(row.final_date) }}
          </td>
          <td  class="text-sm ">
            <div class="float-end">
              <div>
                <span
                    class="pointer"
                    data-bs-toggle="tooltip"
                    :data-bs-original-title="t('editContract')"
                    :title="t('editContract')"
                    data-bs-placement="top"
                    v-tooltip
                    @click="editarTermo(row.id)"
                >
                  <i class="fas fa-pen text-secondary me-2"></i>
                  {{ t('edit') }}

                </span>
              </div>
              <div>
                <span
                    class="pointer"
                    data-bs-toggle="tooltip"
                    :data-bs-original-title="t('deleteContract')"
                    :title="t('deleteContract')"
                    data-bs-placement="top"
                    v-tooltip
                    @click="deletarTermo(row)"
                >
                  <i class="fas fa-trash text-secondary me-2"></i>
                  {{ t('delete') }}
                </span>
              </div>
            </div>
          </td>
        </template>
      </MyTable>
    </div>
  </div>
</template>
<script>
import { reactive, onMounted, ref, inject, computed } from 'vue'
import { useStore } from 'vuex'
import alunoContratosRepository from "../../../../services/api/alunoContratosRepository";
import MyTable from '../../../../components/MyTable.vue';
import { useRouter, useRoute } from 'vue-router'
import TermoAdesaoForm from "./alunoTermoAdesaoForm.vue";
import { useI18n } from 'vue-i18n'

export default {
  components: {
    TermoAdesaoForm,
    MyTable
  },
  setup () {
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()
    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      listarTermos()
    })

    let showForm= ref(false);
    const colunas = ref([
      {
        label: t('name'),
        field: 'name',
        sortable: 'name'
      },
      {
        label: t('status'),
        field: 'status',
        sortable: 'status'
      },
      {
        label: t('period'),
        field: 'initial_date',
        sortable: ''
      },
      {
        label: t('actions'),
        field: 'actions'
      }
    ])

    const state = reactive({
      termosLista: [],
      termoId: 0
    })

    const listarTermos = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      alunoContratosRepository.TermosGet().then(response => {
        store.commit('SET_SPLASH_SCREEN', false)
        state.termosLista = []

        if (response.data.success) {
          state.termosLista = response.data.data

        }
      }).catch((error) => {
        store.commit('SET_SPLASH_SCREEN', false)
        swal({
          icon: 'error',
          title: t('errorFetchingContracts'),
          text: error.message
        })
      })
    }


    function editarTermo(id) {
      state.termoId = id
      formularioTermo(true)
    }

    function deletarTermo(item) {

      swal({
        title: t('areYouSure'),
        text: `${t('doYouWantToDelete')} ${item.name}`,
        showCancelButton: true,
        confirmButtonText: t('yesDelete'),
        cancelButtonText: t('noCancel'),
        reverseButtons: true,
        customClass: {
          confirmButton: "btn bg-gradient-success",
          cancelButton: "btn bg-gradient-danger",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          deletarTermoConfirma(item.id)
        }
      })
    }

    function deletarTermoConfirma(id) {
      store.commit('SET_SPLASH_SCREEN', true)
      alunoContratosRepository.TermoDelete(id).then(response => {
        store.commit('SET_SPLASH_SCREEN', false)
        if(response.data.success) {
          swal({
            title: t('removed'),
            text: t('contractRemovedSuccessfully'),
            icon: "success",
            customClass: {
              confirmButton: "btn bg-gradient-success",
            },
            buttonsStyling: false,
          }).then(() => {
            listarTermos()
          })
        }
      }).catch(error => {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error.message)
        swal({
          icon: 'error',
          title: t('errorDeletingContract'),
          text: error.message
        })
      })
    }

    function formularioTermo(show = true) {
      showForm.value = show
      if(!show) {
        state.termoId = 0
        listarTermos()
      }
    }



    return {
      state,
      colunas,
      editarTermo,
      deletarTermo,
      formularioTermo,
      showForm,
      t
    }
  }
}
</script>